import classNames from "classnames";
import {useContext} from "react";
import {FiLogOut, FiMessageSquare, FiX} from "react-icons/fi";

import {useCurrentUserContext, useZendeskMessenger} from "@/components/context/hooks.ts";
import {Divider} from "@/components/divider/Divider.tsx";
import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {NavBarContext} from "@/components/navBar/NavBar.utils.tsx";
import {NavBarItem} from "@/components/navBar/subComponents/NavBarItem/NavBarItem.tsx";
import {logoutZendeskMessaging} from "@/lib/integrations/zendesk.ts";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {displayForUserAccessLevel} from "@/lib/types/accounts.ts";

import styles from "./NavBarProfileMobileMenu.module.scss";

export const NavBarProfileMobileMenu = () => {
  const {user} = useCurrentUserContext();
  const {setIsProfileMenuOpen} = useContext(NavBarContext);
  const {open: openMessenger} = useZendeskMessenger();

  if (!user) return null;

  return (
    <div className={classNames(styles.menuContainer, "overflow-y-auto")}>
      <div className={styles.menuHeader}>
        <div className={styles.profileName}>
          <div className="pulseTextBodySmallBold">
            {user.first_name} {user.last_name}
          </div>
          <div className="pt-1 pulseTextBodySmall pulse-color-gray-700">{displayForUserAccessLevel(user)}</div>
        </div>
        <IconButton
          icon={FiX}
          variant={"ghost"}
          size={"fitIcon"}
          iconProps={{
            size: "menuIcon",
          }}
          className={"pulse-color-gray-900"}
          onClick={() => setIsProfileMenuOpen(false)}
        />
      </div>
      <ul className="d-flex flex-column flex-grow-1 px-3 gap-2">
        <Divider />
        {user?.has_admin_access && (
          <NavBarItem className={styles.menuEntry} name="Account Details" to="/accounts/account-details" />
        )}
        <NavBarItem className={styles.menuEntry} name="User Profile" to="/accounts/profile" />
        <NavBarItem
          className={styles.menuEntry}
          name="Getting Started"
          to="https://support.uptime.com/hc/en-us/articles/360001311220-Getting-Started-With-Uptime-com"
          target={"_blank"}
        />
        <NavBarItem
          className={styles.menuEntry}
          name="Documentation"
          to="https://support.uptime.com"
          target={"_blank"}
        />
        <NavBarItem
          as="button"
          type="button"
          className={classNames(styles.menuEntry, styles.menuEntryWithIcon)}
          name="Contact Support"
          icon={FiMessageSquare}
          onClick={openMessenger}
        />
        <Divider />
        <NavBarItem
          className={classNames(styles.menuEntry, styles.menuEntryWithIcon)}
          name="Log out"
          to={`${URL_ORIGINAL_WEBSITE}/accounts/logout`}
          target={"_blank"}
          icon={FiLogOut}
          onClick={logoutZendeskMessaging}
        />
      </ul>
    </div>
  );
};
